import { useEffect, useState } from 'react';
export const useDebounceFn = (fn, delay) => {
  const [timeoutId, setTimeoutId] = useState(null);
  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);
  const debouncedFn = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
    setTimeoutId(newTimeoutId);
  };
  return debouncedFn;
};
//# sourceMappingURL=use-debounce-fn.js.map